import React, { useState, useEffect } from "react";

// import TodoList from './TodoList';

import Home from "./components/Auth-user/Todos";
// import TaskPage from "./components/Auth-user/TaskPage";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import { useAuth, AuthProvider } from "./contexts/AuthContext";

import Form from "./components/Auth-user/Form";
import Login from "./components/Auth-user/Login";
import Dashboard from "./components/Auth-user/Dashboard";
import Signup from "./components/Auth-user/Signup";
import ForgotPassword from "./components/Auth-user/ForgotPassword";
// import TaskFeedback from "./components/Auth-user/TaskFeedback";

import { Homepage } from "./components/Home/Home";
import PrivateRoute from "./components/Auth-user/PrivateRoutes";
// import UploadImage from './components/UploadImage';
import "./App.css";
import "./index.css";

import Navbars from "./components/Navbar";
import { Footer } from "./components/footer";
import { Blog } from "./pages/Info";
// import {ProgressForm} from "./components/Home/Progress"
// import {ProgressPage} from "./components/Home/progresspage"
import { Terms } from "./pages/Terms";
import { Privacy } from "./pages/Privacy";
import { About } from "./pages/About";
import { Rundoit } from "./pages/Rundoit"
import { Contact } from "./pages/Contact";
import { Demo } from "./pages/Demo";
import Pricing from "./components/Pricing/Pricing";
import SimpleCalendar from "./components/Auth-user/SimpleCalendar";
// import { Progress } from "./pages/Progress"
// import { Health } from "./pages/Health"
// import TaskPages from "./components/Home/TaskPage";

// Onboarding components
import { OnboardingFlow } from "./components/Onboarding";

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

function AppContent() {
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [user, setUser] = useState(null);
  const { currentUser } = useAuth();

  useEffect(() => {
    const hasCompletedOnboarding = currentUser
      ? localStorage.getItem(`rundoit_onboarding_completed_${currentUser.uid}`)
      : null;
    if (currentUser && !hasCompletedOnboarding) {
      setShowOnboarding(true);
      setUser(currentUser);
    } else {
      setShowOnboarding(false);
    }
  }, [currentUser]);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
  };

  return (
    <div className="App">
      {showOnboarding ? (
        <OnboardingFlow
          user={user}
          onComplete={handleOnboardingComplete}
        />
      ) : (
        <>
          <Navbars />
          <Switch>
            <Route
              path="/general"
              render={() => currentUser ? <Redirect to="/user" /> : <Homepage />}
            />
            <Route path="/signup" component={Signup} />
            <Route path="/info" component={Blog} />
            <Route path="/form" component={Form} />
            <Route path="/features" component={Rundoit} />
            <PrivateRoute path="/calendar" component={SimpleCalendar} />
            <Route path="/contact" component={Contact} />
            <Route path="/demo" component={Demo} />
            <Route path="/terms" component={Terms} />
            <Route path="/about" component={About} />
            <Route path="/privacy" component={Privacy} />
            <Route path="/pricing" component={Pricing} />
            <PrivateRoute exact path="/user" component={Home} />
            <PrivateRoute path="/profile" component={Dashboard} />
            <Route path="/login" component={Login} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route
              path="/"
              render={() => currentUser ? <Redirect to="/user" /> : <Homepage />}
            />
          </Switch>
          <Footer />
        </>
      )}
    </div>
  );
}
